export enum TIME_GROUP {
  DAY = 'day',
  WEEK = 'week',
  MONTH = 'month',
}

export interface DateRange {
  startDay: string; // DATE_FORMATS.API
  endDay: string; // DATE_FORMATS.API
  timeGroup: TIME_GROUP;
}
